import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	container: {
		position: "relative"
	},
	circularProgressContainer: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		zIndex: 9
	}
})

export default useStyles
